import React from 'react';
import { Handle, Position } from 'reactflow';
import { Timer } from 'lucide-react';
import { cn } from '@/lib/utils';

// Simple duration formatter
const formatDuration = (ms: number): string => {
  if (ms < 1000) return `${ms}ms`;
  if (ms < 60000) return `${(ms / 1000).toFixed(1)}s`;
  return `${(ms / 60000).toFixed(1)}min`;
};

interface DelayNodeData {
  label?: string;
  duration?: number; // in milliseconds
}

export default function DelayNode({ 
  data, 
  selected 
}: { 
  data: DelayNodeData; 
  selected?: boolean 
}) {
  return (
    <div className={cn(
      "min-w-[150px] rounded-lg",
      "bg-card",
      "border-2 transition-all duration-fast",
      selected 
        ? "border-text-secondary-light dark:border-text-secondary shadow-glow-focus" 
        : "border-border shadow-md hover:shadow-lg"
    )}>
      {/* Connection Handle */}
      <Handle
        type="target"
        position={Position.Top}
        className="!w-3 !h-3 !border-2 !bg-text-secondary-light dark:!bg-text-secondary !border-text-secondary-light dark:!border-text-secondary"
        style={{ top: '-6px' }}
      />

      {/* Node Body */}
      <div className="flex items-center gap-3 p-3">
        <div className="w-10 h-10 rounded bg-muted flex items-center justify-center">
          <Timer className="w-5 h-5 text-muted-foreground" />
        </div>
        <div className="flex-1">
          <div className="text-sm font-semibold text-foreground">
            Delay
          </div>
          <div className="text-xs text-muted-foreground/70">
            {formatDuration(data.duration || 1000)}
          </div>
        </div>
      </div>

      <Handle
        type="source"
        position={Position.Bottom}
        className="!w-3 !h-3 !border-2 !bg-text-secondary-light dark:!bg-text-secondary !border-text-secondary-light dark:!border-text-secondary"
        style={{ bottom: '-6px' }}
      />
    </div>
  );
}

